import { render, staticRenderFns } from "./TLDsPage.vue?vue&type=template&id=972b6d16&lang=pug&"
import script from "./TLDsPage.vue?vue&type=script&lang=js&"
export * from "./TLDsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports